import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { IAppState } from '../../../../common/models/store/IAppState';
import { User } from '../../../../common/models/user/User';
import ProfileForm from '../ProfileForm';
import LoaderWrapper from '../../../../components/LoaderWrapper';
import styles from './styles.module.scss';
import { IUserProfileData } from '../../../../common/models/user/IUserProfileData';
import Input from '../../../../components/Input';

interface IProps {
  user: User;
  isSaving: boolean;
}

const ProfilePane: FunctionComponent<IProps> = ({
  user,
  isSaving
}) => {
  const defaultUserData: IUserProfileData = {
    firstName: user.firstName,
    lastName: user.lastName,
    initials: user.initials,
    phoneNumber: user.phoneNumber,
    team: { id: user.teamId, name: user.teamName }
  };

  return (
    <LoaderWrapper loading={isSaving} transparent>
      <div className={styles.profilePane}>
        <div>
          <span className="settingsTitle">
            <FormattedMessage id="profilePane.personalInfo" defaultMessage="Personal information" />
          </span>
          <ProfileForm defaultUserData={defaultUserData} />
        </div>
        <div className={styles.loginInfo}>
          <span className="settingsTitle m-0">
            <FormattedMessage id="profilePane.loginInfo" defaultMessage="Login information" />
          </span>
          <Input
            label={{ id: 'emailAddress', defaultMessage: 'Email address' }}
            disabled
            variant="underlined"
            value={user.email}
            className={styles.emailInput}
          />
        </div>
      </div>
    </LoaderWrapper>
  );
};

const mapStateToProps = ({
  user: { user },
  settings: { profile: { isSaving } }
}: IAppState) => ({ user: user as User, isSaving });

export default connect(mapStateToProps)(ProfilePane);
